module.exports = __webpack_public_path__ + "static/media/Вейде Андрей Иванович_Год театра. Случайные размышления дилетанта_Красноярский край_page-0005.jpg";